<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-13 19:08:24
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-19 09:51:03
 * @FilePath: \hzs-nutra-wecom-shop\src\views\closingBooks\closingBooks.vue
 * @Description: 关账记录
-->

<template>
  <div class="page-container">
    <div class="mainContent">
      <div
        class="shopName flex justify-ss align-center"
        @click="handleChangeShop"
      >
        <span>{{ state.currentShopName }}</span>
        <i class="db icon arrowLeftSingleIcon"></i>
      </div>

      <div class="inner">
        <van-pull-refresh
          v-if="state.listData.length"
          v-model="state.isRefresh"
          @refresh="onRefresh"
        >
          <van-list
            v-model:loading="state.listLoading"
            :finished="state.finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              v-for="item in state.listData"
              :key="item"
              class="customerItem"
            >
              <div class="time">
                {{ item.created_at }}
              </div>

              <van-divider></van-divider>

              <div class="msg">
                <div class="flex justify-sb align-center">
                  <span class="label">订单金额：</span>
                  <span class="value">{{ item.total_amount }} 元</span>
                </div>
                <div class="flex justify-sb align-center">
                  <span class="label">订单数：</span>
                  <span class="value">{{ item.total_orders }} 单</span>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
        <div v-else class="emptyBox flex align-center justify-sc">
          <van-empty
            :image="emptyCustomerImg"
            image-size="150"
            description="暂无账单记录"
          />
        </div>
      </div>
    </div>

    <div class="bottom_button_box">
      <button class="btn btn-default" @click="handleCreateCustomer">
        返回
      </button>
      <button
        class="btn btn-primary"
        :class="state.status ? 'done' : ''"
        @click="handleTakeOrder"
      >
        {{ state.status ? "今日已关账" : "立即关账" }}
      </button>
    </div>

    <van-popup v-model:show="state.showShop" round position="bottom">
      <van-picker
        title="选择门店"
        :columns="state.shopOptions"
        @confirm="onShopConfirm"
        @cancel="onShopCancel"
        @change="onShopChange"
      />
    </van-popup>
  </div>
</template>

<script lang="ts" setup>
import emptyCustomerImg from "@/assets/img/customer/emptyCustomer.png";
import { showFailToast, showSuccessToast, showConfirmDialog } from "vant";
import ClosingBooksApi from "@/utils/api/closingBooks";
import authApi from "@/utils/api/auth";

// --------------------------------------- 变量
let shop_clerk_uuid = undefined;
const router = useRouter();
const state = reactive({
  status: false,
  listData: [],

  pagination: {
    page: 1,
    lastPage: 1,
    pageSize: 10,
    lastPageSize: 1,
    total: 0,
  },

  isRefresh: false,
  finished: true,
  listLoading: false,

  selectedId: undefined,

  currentShopName: undefined,
  currentShopId: undefined,
  lastShopName: undefined,
  lastShopId: undefined,
  showShop: false,
  shopOptions: [],
});
// --------------------------------------- 方法、事件
onMounted(async () => {
  shop_clerk_uuid = localStorage.getItem("shop_clerk_uuid");
  await getShopList();
  getData();
  getBookingStatus();
});
// 下拉刷新回调
const onRefresh = async () => {
  // 重置列表状态
  state.finished = false;
  state.listLoading = true; // 先让 List 进入 loading 状态（或者直接在这里处理）

  state.listData = [];

  state.pagination.lastPage = state.pagination.page;
  state.pagination.lastPageSize = state.pagination.pageSize;

  state.pagination.page = 1;
  state.pagination.pageSize =
    state.pagination.lastPage * state.pagination.lastPageSize;

  await getData();
  await nextTick();
  state.isRefresh = false;
  state.pagination.pageSize = state.pagination.lastPageSize;
  state.listLoading = false;
};

// 上拉加载回调 (由 van-list 触发)
const onLoad = async () => {
  // 如果是刷新过程中触发的 load，则不重复请求
  if (state.isRefresh) {
    state.listLoading = false;
    return;
  }

  if (state.listData.length < state.pagination.total) {
    state.pagination.page += 1;
    await getData();
  }

  state.finished = true;
  state.listLoading = false;
};

// 关账
function handleTakeOrder() {
  showConfirmDialog({
    title: "提示",
    message: "是否确认今日关账？",
    confirmButtonColor: "#DCBB89",
    cancelButtonColor: "#999999",
    width: "90%",
  })
    .then(() => {
      ClosingBooksApi._closeBook({
        shop_clerk_uuid,
        shop_uuid: state.currentShopId || undefined,
      })
        .then((res) => {
          if (res?.code === 200) {
            showSuccessToast("关账成功");
          } else {
            showFailToast(res?.msg || "关账失败");
          }

          getBookingStatus();
        })
        .catch((err) => {
          showFailToast(res?.msg || "关账失败");
        });
    })
    .catch(() => {});
}

// 返回
function handleCreateCustomer() {
  router.push("/createCustomer");
}

// 选择门店
function handleChangeShop() {
  state.lastShopName = state.currentShopName;
  state.lastShopId = state.currentShopId;
  state.showShop = true;
}
// 确认选择门店
function onShopConfirm() {
  state.showShop = false;
  getData();
  getBookingStatus();
}
// 取消选择门店
function onShopCancel() {
  state.currentShopName = state.lastShopName;
  state.currentShopId = state.lastShopId;
  state.showShop = false;
}
// 切换 选择门店
function onShopChange({ selectedValues }) {
  let target = state.shopOptions.find(
    (item) => item.value === selectedValues[0],
  );
  if (target) {
    state.currentShopName = target?.text || undefined;
    state.currentShopId = target?.value || undefined;
  }
}

// --------------------------------------- 请求
const getData = () => {
  ClosingBooksApi._booksList({
    shop_clerk_uuid,
    shop_uuid: state.currentShopId || undefined,
    page: state.pagination.page,
    page_size: state.pagination.pageSize,
  }).then((res) => {
    state.listData = res?.data || [];
    state.pagination.total = res?.total || res?.cnt || 0;
  });
};
async function getShopList() {
  let res = await authApi.myDepartments();
  state.shopOptions = (res?.data || [])
    .filter((v) => v.department.type == 2)
    .map((v) => v.department);

  state.currentShopName = state.shopOptions[0]?.name;
  state.currentShopId = state.shopOptions[0]?.uuid;
}
function getBookingStatus() {
  ClosingBooksApi._bookingStatus({
    shop_uuid: state.currentShopId || undefined,
    shop_clerk_uuid,
  }).then((res) => {
    state.status = res?.data?.today_is_closed || false;
  });
}
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.icon {
  width: 28px;
  height: 28px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  &.arrowLeftSingleIcon {
    width: 14px;
    height: 14px;
    background-image: url("@/assets/img/icons/arrowLeftSingle.png");
  }
}

.mainContent {
  padding: 0;

  .shopName {
    height: 52px;
    padding: 0 29px;
    background: #fff;

    span {
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-right: 4px;
    }
  }

  .inner {
    padding: 10px 18px;

    .emptyBox,
    .van-pull-refresh {
      min-height: 100%;

      .customerItem {
        padding: 6px;
        background: #ffffff;
        padding: 17px 11px 16px;
        border-radius: 8px;

        &:not(:last-child) {
          margin-bottom: 10px;
        }

        .time {
          height: 22px;
          font-family:
            PingFang SC,
            PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .msg {
          & > div:first-child {
            margin-bottom: 15px;
          }

          span {
            height: 22px;
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 400;
            font-size: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          span.label {
            color: #666666;
          }
          span.value {
            color: #333333;
          }
        }
      }
    }
  }
}

.btn-primary.done {
  background: #999999;
}
</style>
